export const CONFIRM = 0
export const NOTIFY = 1
export const MESSAGE = 2
export const ACCEPT = 10
export const YES_NO = 11
export const EXECUTE = 12
